export default {
    clearPromptChar: Boolean, 
    culture: String, 
    mask: String, 
    promptChar: String, 
    rules: Object, 
    unmaskOnPost: Boolean, 
    value: String, 

    // Events
    change: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoMaskedTextBox/MaskedTextBoxProps.js